/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NotificationChannelWebhookUrl } from './NotificationChannelWebhookUrl';
import {
    NotificationChannelWebhookUrlFromJSON,
    NotificationChannelWebhookUrlFromJSONTyped,
    NotificationChannelWebhookUrlToJSON,
    NotificationChannelWebhookUrlToJSONTyped,
} from './NotificationChannelWebhookUrl';
import type { NotificationChannelEmail } from './NotificationChannelEmail';
import {
    NotificationChannelEmailFromJSON,
    NotificationChannelEmailFromJSONTyped,
    NotificationChannelEmailToJSON,
    NotificationChannelEmailToJSONTyped,
} from './NotificationChannelEmail';
import type { ChannelTypeEnum } from './ChannelTypeEnum';
import {
    ChannelTypeEnumFromJSON,
    ChannelTypeEnumFromJSONTyped,
    ChannelTypeEnumToJSON,
    ChannelTypeEnumToJSONTyped,
} from './ChannelTypeEnum';

/**
 * Serializer for notification channels.
 * @export
 * @interface NotificationChannel
 */
export interface NotificationChannel {
    /**
     * 
     * @type {number}
     * @memberof NotificationChannel
     */
    readonly id: number;
    /**
     * 
     * @type {number}
     * @memberof NotificationChannel
     */
    owner?: number | null;
    /**
     * 
     * @type {ChannelTypeEnum}
     * @memberof NotificationChannel
     */
    channelType: ChannelTypeEnum;
    /**
     * 
     * @type {NotificationChannelEmail}
     * @memberof NotificationChannel
     */
    email?: NotificationChannelEmail | null;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationChannel
     */
    readonly active: boolean;
    /**
     * 
     * @type {NotificationChannelWebhookUrl}
     * @memberof NotificationChannel
     */
    webhookUrl?: NotificationChannelWebhookUrl | null;
}



/**
 * Check if a given object implements the NotificationChannel interface.
 */
export function instanceOfNotificationChannel(value: object): value is NotificationChannel {
    if (!('id' in value) || value['id'] === undefined) return false;
    if ((!('channelType' in (value as Record<string, any>)) && !('channel_type' in (value as Record<string, any>))) || ((value as Record<string, any>)['channelType'] === undefined && (value as Record<string, any>)['channel_type'] === undefined)) return false;
    if (!('active' in value) || value['active'] === undefined) return false;
    return true;
}

export function NotificationChannelFromJSON(json: any): NotificationChannel {
    return NotificationChannelFromJSONTyped(json, false);
}

export function NotificationChannelFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationChannel {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'owner': json['owner'] === undefined ? undefined : json['owner'] === null ? null : json['owner'],
        'channelType': ChannelTypeEnumFromJSON(json['channel_type']),
        'email': json['email'] === undefined ? undefined : json['email'] === null ? null : NotificationChannelEmailFromJSON(json['email']),
        'active': json['active'],
        'webhookUrl': json['webhook_url'] === undefined ? undefined : json['webhook_url'] === null ? null : NotificationChannelWebhookUrlFromJSON(json['webhook_url']),
    };
}

export function NotificationChannelToJSON(json: any): NotificationChannel {
    return NotificationChannelToJSONTyped(json, false);
}

export function NotificationChannelToJSONTyped(value?: Omit<NotificationChannel, 'id'|'active'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'owner': value['owner'],
        'channel_type': ChannelTypeEnumToJSON(value['channelType']),
        'email': NotificationChannelEmailToJSON(value['email']),
        'webhook_url': NotificationChannelWebhookUrlToJSON(value['webhookUrl']),
    };
}

